import { useAuth } from '@/lib/auth/auth';
import { organizationInvitationKeys } from '@/features/workspaces/useOrganizationInvitationPreview';
import type { OrganizationInvitationPreview } from '@/lib/api/apiTypes';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useOrganizationInvitationActions(token: string) {
  const request = useAuth((state) => state.request);
  const queryClient = useQueryClient();

  const acceptMutation = useMutation({
    mutationFn: () =>
      request<OrganizationInvitationPreview>(`/invitations/${token}/accept`, {
        method: 'POST',
      }),
    onSuccess: (preview) => {
      queryClient.setQueryData(organizationInvitationKeys.preview(token), preview);
    },
  });

  const declineMutation = useMutation({
    mutationFn: () =>
      request<{ declined: boolean }>(`/invitations/${token}/decline`, {
        method: 'POST',
      }),
    onSuccess: () => {
      queryClient
        .invalidateQueries({ queryKey: organizationInvitationKeys.preview(token) })
        .catch(() => undefined);
    },
  });

  return {
    acceptMutation,
    declineMutation,
  };
}
